import { useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";

const rules = [
  {
    title: "Playing Field",
    body: "All U-15 and U-17 teams shall play on a full-size football pitch (11-a-side).",
  },
  {
    title: "Squad Size",
    body: "Each team must register a minimum of 15 players and a maximum of 25 players.",
  },
  {
    title: "Player Complaints",
    body: "Only the team coach or an officially designated team representative is permitted to raise complaints concerning players from opposing teams. Players are not allowed to submit complaints.",
  },
  {
    title: "Discipline and Misconduct",
    body: "Any team involved in misconduct, violence, or disorderly behaviour caused by its players, officials, or supporters shall be subject to immediate disqualification from the tournament.",
  },
  {
    title: "Team Jerseys",
    body: "Every team must bring two sets of jerseys in different colours to avoid colour clashes with opposing teams.",
  },
  {
    title: "Official Protests",
    body: "All official protests and complaints must be submitted exclusively to the designated FKF officials. No other person or authority shall handle official protests.",
  },
  {
    title: "Reporting Time and Match Readiness",
    body: "All teams must arrive at the venue by 8:00 AM and be fully dressed and ready to play by 8:30 AM. Teams are expected to observe these timings strictly to ensure the smooth running of the tournament.",
  },
];

function Rules() {
  const team = useLocation().state?.team;
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-brand-cream">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        team={team}
      />

      <div className="flex-1 p-6">
        <button
          onClick={() => setSidebarOpen(true)}
          className="md:hidden mb-4 bg-brand-dark text-white px-3 py-2 rounded-lg text-xl"
        >
          ☰
        </button>

        <h1 className="text-2xl font-bold text-brand-red mb-4">
          NextGen Bonanza Tournament Rules
        </h1>

        <div className="space-y-4">
          {rules.map((rule, index) => (
            <div key={rule.title} className="bg-white rounded-2xl shadow p-5">
              <h2 className="text-lg font-bold text-brand-dark mb-1">
                {index + 1}. {rule.title}
              </h2>
              <p className="text-sm text-gray-700">{rule.body}</p>
            </div>
          ))}
        </div>

        <p className="mt-6 text-sm font-semibold text-brand-dark">
          All teams are expected to observe these rules and uphold the spirit of
          fair play, discipline, and respect throughout the NEXTGEN BONANZA
          tournament.
        </p>
      </div>
    </div>
  );
}

export default Rules;
